import { Component } from 'preact'
import styles from './Input.scss'

export default class Input extends Component {
    render({ className, fullWidth, error, errorMessage, ...props }) {
        const fullWidthClass = fullWidth ? styles.fullWidth : ''
        const errorClass = error ? styles.error : ''

        return (
            <div>
                <div class={`${styles.input} ${className} ${fullWidthClass} ${errorClass}`}>
                    <input {...props} />
                </div>
                {error ? <span className={styles.errorMessage}>{errorMessage}</span> : null}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./components/Input/Input.js